import * as actionTypes from './actionTypes';
import axiosInstance from '../../axios-instance';

export const developerSuccess = payload => {
  return {
    type: actionTypes.DEVELOPERS_SUCCESS,
    payload: payload
  };
};

export const developerStart = () => {
  return {
    type: actionTypes.DEVELOPERS_START
  };
};

export const developerFail = error => {
  return {
    type: actionTypes.DEVELOPERS_FAIL,
    error: error
  };
};
export const getDevelopersList = (getData, hideLoader) => {
  return dispatch => {
    if (!(hideLoader !== undefined && hideLoader === true)) {
      //dispatch(developerStart());
    }
    axiosInstance()
      .get('/developers.json', { params: getData })
      .then(response => {
        dispatch(developerSuccess({ ...response.data, loaded: true }));
      })
      .catch(err => {
        if (err.response !== undefined) {
          dispatch(developerFail(err.response.data.message));
        } else {
          dispatch(developerFail('Problem with connection to API.'));
        }
      });
  };
};

export const createDeveloper = (postData, history) => {
  return dispatch => {
    dispatch(developerStart());
    axiosInstance()
      .post('/developers.json', postData)
      .then(response => {
        history.push('/developers/' + response.data.id);
        dispatch(developerSuccess({ list: [], loaded: false }));
      })
      .catch(err => {
        if (err.response !== undefined) {
          dispatch(developerFail(err.response.data.message));
        } else {
          dispatch(developerFail('Problem with connection to API.'));
        }
      });
  };
};

export const editDeveloper = (entityId, postData, callback) => {
  return dispatch => {
    dispatch(developerStart());
    axiosInstance()
      .put(`/developers/${entityId}.json`, postData)
      .then(response => {
        dispatch(
          developerSuccess({ viewItem: response.data, list: [], loaded: false })
        );
        callback();
      })
      .catch(err => {
        if (err.response !== undefined) {
          dispatch(developerFail(err.response.data.message));
        } else {
          dispatch(developerFail('Problem with connection to API.'));
        }
      });
  };
};

export const getDeveloper = entityId => {
  return dispatch => {
    //dispatch(loaderStart());
    axiosInstance()
      .get('/developers/' + entityId + '.json')
      .then(response => {
        dispatch(developerSuccess({ viewItem: response.data }));
        //dispatch(loaderStop());
      })
      .catch(err => {
        if (err.response !== undefined) {
          dispatch(developerFail(err.response.data.message));
        } else {
          dispatch(developerFail('Problem with connection to API.'));
        }
        //dispatch(loaderStop());
      });
  };
};
